import React from 'react'
import MainSlider from '~/main/components/MainSlider'
import FortyFiveYearsOfTheZeds from '~/programs/components/45YearsOfTheZeds';
import FortyFive from '~/main/components/45';
import FromAToTripleZed from '~/features/components/FromAToTripleZed';
import AnnouncersTopTen from '~/features/components/AnnouncersTopTen';
import Lineup from '~/programs/components/Lineup';
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import TopSection from './TopSection'
import AprilAtonementBanner from './AprilAtonementBanner'
import MainBanner from './MainBanner'
import Events from './Events'
import SubPacks from './SubPacks'
import MajorPrizes from './MajorPrizes'
import StationUpdates from './StationUpdates'
import Prizes from './Prizes'
import DailyPrize from './DailyPrize'
import About from './About'
import Top20Feature from './Top20Feature'
import AOTW from './AOTW'
import BNA from './BNA'
import Hot100 from './Hot100'
import EOYTop10 from './EOYTop10'
import Footer from './Footer'
import { fetchTop20IfNeeded, fetchTop20Counter, fetchPodcastIfNeeded } from '~/features/actions'
import { onAirFM, onAirZD, fetchFMProgramsIfNeeded, fetchZDProgramsIfNeeded, programEpisodeWithPlaylist, fmLineup, fetchFortyFive, fetchProgramIfNeeded,  } from '~/programs/actions'
import { fetchBNAIfNeeded, fetchAOTWIfNeeded, fetchRadiothonDailyIfNeeded, fetchStationUpdatesIfNeeded, fetchEOYTop10IfNeeded } from '~/features/actions'
import { fetchEventsIfNeeded } from '~/events/actions'
import SoundsLike from '~/programs/components/SoundsLike';
import RadiothonBanner from './RadiothonBanner2024';
import Zed50Banner from './Zed50Banner';
import { Hot100Banner } from './Hot100Banner';
import FiftyEvents from './FiftyEvents';
class Main extends React.Component{

  static fetchData(store) {
    return Promise.all([
      store.dispatch(onAirFM()),
      store.dispatch(onAirZD()),
      store.dispatch(fetchFMProgramsIfNeeded()),
      store.dispatch(fetchZDProgramsIfNeeded()),
      store.dispatch(fetchTop20IfNeeded()),
      store.dispatch(fetchStationUpdatesIfNeeded()),
      store.dispatch(fetchEventsIfNeeded()),
      store.dispatch(fetchBNAIfNeeded()),
      store.dispatch(fetchAOTWIfNeeded()),
      store.dispatch(fetchEOYTop10IfNeeded()),
			store.dispatch(fetchFortyFive()),
			store.dispatch(fetchPodcastIfNeeded()),
      store.dispatch(fetchProgramIfNeeded('sounds-like-community-radio')),
      
      store.dispatch(programEpisodeWithPlaylist('sounds-like-community-radio', '2022-09-06'))
    ]).then( () => {
      console.log('lineup?')
		  return store.dispatch(fmLineup());
		}).then ( 
      () => { 
        console.log('all promises')
      }
    )
  }

  render() {
    const {programsFM, programsZD, onAirFM, onAirZD, programs, selectedEpisodeDate, radiothonDaily, stationUpdates, search} = this.props
    if (programsFM.lastUpdated> 0 && onAirFM.program !== null ) {
      return (
      <div className='radiothon-front'>
        {/* <div className="april-atonement"> 
        <AprilAtonementBanner />
          <div class="margin">
            <h2 style={{textAlign: 'center'}}>We appreciate all the subscriber support over April!</h2>
            <p style={{ fontSize: '24px' }}> */}
              {/* Thank you to everyone in the community who joined us to make April Atonement a successful campaign, old and new alike, your continued support helps us make truly independent, people powered radio.
            </p>
            <p style={{ fontSize: '24px', paddingBottom: '2em' }}>
              Prizes will be drawn in the coming days, so best of luck to those in the running!
            </p>
          </div>
          <div className="margin" style={{paddingBottom: '4em'}}><Link to="/subscribe"><h2 className="phat" style={{ fontSize: '10vw', textAlign: 'center' }}>THANKS!</h2></Link></div> */}
          {/* <AprilAtonementBanner />
          <div class="margin">
            <h2 style={{textAlign: 'center'}}>Subscribe to 4ZZZ this April <br/> atone your non-subscriber sins<br/> and maybe even win something!</h2>
            <p style={{ fontSize: '24px' }}>
              Why subscribe during April Atonement? We’ve spent the last 50 years helping connect and amplify the voices of our local communities! Subscribing to 4ZZZ means YOU’RE supporting local, independent arts, media and culture.
            </p>
            <p style={{ fontSize: '24px', paddingBottom: '2em' }}>

            </p>
          </div>
          <div className="margin" style={{paddingBottom: '4em'}}><Link to="/subscribe"><h2 className="phat" style={{ fontSize: '10vw', textAlign: 'center' }}>Subscribe</h2></Link></div>
          <Prizes />
          <div className="margin" style={{paddingBottom: '4em'}}><Link to="/april-atonement"><h2 style={{ textAlign: 'center' }}>Read the full April Atonement details here</h2></Link></div> */}
        {/* </div> */}
        {/* <Hot100Banner style={{ "--container-width": '100vw' }}/> */}
        
        <Zed50Banner />

        {/* <MainBanner /> */}
        {/* <Events /> */}
        <FiftyEvents />
        {/* <RadiothonBanner /> */}
        {/* <Prizes category="april-atonement" /> */}
        {/* <Prizes category="radiothon" /> */}
				<Lineup />

        {/* <EOYTop10 /> */}
        {/* <AnnouncersTopTen /> */}
        {/* <SoundsLike /> */}
				<SubPacks />
        <AOTW />

        {/* <BNA /> */}
        <Top20Feature />
				{/* <FortyFive /> */}
				{/* <FortyFiveYearsOfTheZeds /> */}
        <FromAToTripleZed />
        <StationUpdates />
        <Footer />
      </div>
      )
    } else {
      return ( null )
    }
  }
}

const dispatchToProps = (dispatch) => {
    return bindActionCreators({
      fetchEventsIfNeeded,
      receiveEvents
    }, dispatch)
}

const mapDispatchToProps = {
}

function mapStateToProps(state) {
  const { events, programsFM, onAirFM, radiothonDaily, stationUpdates } = state
  const {
    isFetching,
    lastUpdated,
    items
  } = events || {
    isFetching: true,
    items: []
  }
 
  return {
    events, programsFM, onAirFM, radiothonDaily, stationUpdates
  }
}

//export default connect(dispatchToProps)(Main)
export default connect(mapStateToProps)(Main)
